import { render, staticRenderFns } from "./Dental.vue?vue&type=template&id=4dbcc89a"
import script from "./Dental.vue?vue&type=script&lang=js"
export * from "./Dental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports